/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardContentUpdateRequest } from './RewardContentUpdateRequest';
import {
    RewardContentUpdateRequestFromJSON,
    RewardContentUpdateRequestFromJSONTyped,
    RewardContentUpdateRequestToJSON,
} from './RewardContentUpdateRequest';

/**
 * An edit to a schedule that has not ended. Rewards left out are unchanged.
 * @export
 * @interface RewardScheduleContentUpdateRequest
 */
export interface RewardScheduleContentUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof RewardScheduleContentUpdateRequest
     */
    rulesLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RewardScheduleContentUpdateRequest
     */
    supportLink?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardScheduleContentUpdateRequest
     */
    promoText?: Array<string>;
    /**
     * 
     * @type {Array<RewardContentUpdateRequest>}
     * @memberof RewardScheduleContentUpdateRequest
     */
    rewards: Array<RewardContentUpdateRequest>;
}

/**
 * Check if a given object implements the RewardScheduleContentUpdateRequest interface.
 */
export function instanceOfRewardScheduleContentUpdateRequest(value: object): value is RewardScheduleContentUpdateRequest {
    if (!('rewards' in value) || value['rewards'] === undefined) return false;
    return true;
}

export function RewardScheduleContentUpdateRequestFromJSON(json: any): RewardScheduleContentUpdateRequest {
    return RewardScheduleContentUpdateRequestFromJSONTyped(json, false);
}

export function RewardScheduleContentUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardScheduleContentUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rulesLink': json['rulesLink'] == null ? undefined : json['rulesLink'],
        'supportLink': json['supportLink'] == null ? undefined : json['supportLink'],
        'promoText': json['promoText'] == null ? undefined : json['promoText'],
        'rewards': ((json['rewards'] as Array<any>).map(RewardContentUpdateRequestFromJSON)),
    };
}

export function RewardScheduleContentUpdateRequestToJSON(value?: RewardScheduleContentUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'rulesLink': value['rulesLink'],
        'supportLink': value['supportLink'],
        'promoText': value['promoText'],
        'rewards': ((value['rewards'] as Array<any>).map(RewardContentUpdateRequestToJSON)),
    };
}

